import { toArray, some, unwrap } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { cons, empty, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { dataUrlToCanvas, readAsDataUrlPromise, readAsArrayBufferPromise, System_String__String_ToOption_Static_Z721C83C5 } from "../Prelude.fs.js";
import * as webpack from "pdfjs-dist/webpack";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import { pdfToCanvas } from "../Bindings/PDF.fs.js";
import { iterate } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { getScanner } from "../Bindings/QRScanner.fs.js";

function region(x, y, width, height) {
    return new (class {
        get x() {
            return x;
        }
        set x(_arg) {
        }
        get y() {
            return y;
        }
        set y(_arg_1) {
        }
        get width() {
            return width;
        }
        set width(_arg_2) {
        }
        get height() {
            return height;
        }
        set height(_arg_3) {
        }
        get downScaledWidth() {
            return unwrap((width > 4000) ? (width / 4) : ((width > 2000) ? (width / 3) : ((width > 1000) ? (width / 2) : undefined)));
        }
        set downScaledWidth(_arg_4) {
        }
        get downScaledHeight() {
            return unwrap((width > 4000) ? (height / 4) : ((width > 2000) ? (height / 3) : ((width > 1000) ? (height / 2) : undefined)));
        }
        set downScaledHeight(_arg_5) {
        }
    }
    )();
}

function scanRegions(scanner, qrScannerEngine, width, height, scanData) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const regionHeight = height / 4;
        const regionWidth = width / 4;
        const regions = ofArray([region(0, 0, regionWidth, regionHeight), region(regionWidth, 0, regionWidth, regionHeight), region(regionWidth * 2, 0, regionWidth, regionHeight), region(regionWidth * 3, 0, regionWidth, regionHeight)]);
        let result = undefined;
        return PromiseBuilder__For_1565554B(promise, regions, (_arg) => {
            const region_1 = _arg;
            return (result == null) ? (PromiseBuilder__Delay_62FBFDE1(promise, () => (scanner.scanImage(scanData, region_1, qrScannerEngine).then((_arg_1) => {
                result = System_String__String_ToOption_Static_Z721C83C5(_arg_1);
                return Promise.resolve();
            }))).catch((_arg_2) => {
                console.warn(some(`Failed to find QR in Region: x:${region_1.x}, y:${region_1.y}, width:${region_1.width}, height:${region_1.height}`), _arg_2);
                return Promise.resolve();
            })) : (Promise.resolve());
        }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(result))));
    }));
}

function scanWhole(scanner, qrScannerEngine, width, height, scanData) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const wholeRegion = region(0, 0, width, height);
        return scanner.scanImage(scanData, wholeRegion, qrScannerEngine).then((_arg) => (Promise.resolve(System_String__String_ToOption_Static_Z721C83C5(_arg))));
    }).catch((_arg_1) => {
        console.warn(some("Failed to find QR in whole File"), _arg_1);
        return Promise.resolve(undefined);
    }))));
}

function scanForQR(scanner, qrScannerEngine, width, height, scanData) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (scanRegions(scanner, qrScannerEngine, width, height, scanData).then((_arg) => {
        const resultOpt = _arg;
        if (resultOpt == null) {
            return scanWhole(scanner, qrScannerEngine, width, height, scanData);
        }
        else {
            const result = resultOpt;
            return Promise.resolve(result);
        }
    }))));
}

function detectQRonPDF(scanner, qrScannerEngine, pdf, scale) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (readAsArrayBufferPromise(pdf).then((_arg) => (webpack.getDocument(_arg).promise.then((_arg_1) => {
        const pdfDoc = _arg_1;
        let qrDetected = false;
        let result = undefined;
        return PromiseBuilder__For_1565554B(promise, rangeDouble(1, 1, pdfDoc.numPages), (_arg_2) => (!qrDetected ? (pdfToCanvas(pdfDoc, _arg_2, scale).then((_arg_3) => {
            const canvasOpt = _arg_3;
            if (canvasOpt != null) {
                const canvas = canvasOpt;
                return scanForQR(scanner, qrScannerEngine, canvas.width, canvas.height, canvas).then((_arg_4) => {
                    iterate((qr) => {
                        qrDetected = true;
                        result = qr;
                    }, toArray(_arg_4));
                    return Promise.resolve();
                });
            }
            else {
                return Promise.resolve();
            }
        })) : (Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(result))));
    }))))));
}

function detectQROnImage(scanner, qrScannerEngine, file) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (readAsDataUrlPromise(file).then((_arg) => (dataUrlToCanvas(_arg).then((_arg_1) => {
        const canvas = _arg_1;
        return scanForQR(scanner, qrScannerEngine, canvas.width, canvas.height, canvas);
    }))))));
}

/**
 * Returns all files and the contents of the first QR code found in the image/pdf.
 */
export function detectQROnFiles(scale, files) {
    const scanner = getScanner();
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let results = empty();
        return scanner.createQrEngine().then((_arg) => {
            const qrScannerEngine = _arg;
            return PromiseBuilder__For_1565554B(promise, files, (_arg_1) => {
                let matchValue;
                const file = _arg_1;
                return ((matchValue = file.type, (matchValue === "application/pdf") ? detectQRonPDF(scanner, qrScannerEngine, file, scale) : ((matchValue === "image/jpg") ? detectQROnImage(scanner, qrScannerEngine, file) : ((matchValue === "image/jpeg") ? detectQROnImage(scanner, qrScannerEngine, file) : ((matchValue === "image/png") ? detectQROnImage(scanner, qrScannerEngine, file) : (Promise.resolve(undefined))))))).then((_arg_2) => {
                    results = cons([file, _arg_2], results);
                    return Promise.resolve();
                });
            }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(results))));
        });
    }));
}

